import { withBoxModel } from "../withBoxModel/withBoxModel";
import { Text as BaseText } from "./text";

const Text = withBoxModel(BaseText);
export { Text };
